// TODO: Add proper return type annotation
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function onError(error: Error) {
  console.debug(`[web3-react] Error: ${error}`)
}
